module.exports = "<div class=\"steps_container\">\n\t<button data-rpoint=\"btn\"></button>\n\t<div class=\"steps\" data-rpoint=\"steps\"></div>\n</div>\n";